import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  BackgroundDiv,
  BottomBtnArea,
  ContentBody,
  HeaderTitle,
  NoticeText,
  SelectDivArea,
  SelectedDiv,
} from "./ReceiptStyle";

import { Button, Layer } from "../../../components";
import { AppContext } from "../../../components/AppProvider";
import List from "../../../components/UI/List/List";
import { _O } from "../../../modules/utils";
import { checkNum10, getWeekday } from "../../../modules/utils/CheckLogic";
import { IC, ListIcon } from "../../../resources/Assets";
import PurpleDot from "../../../resources/images/nftf/PurpleDot.svg";
import ChevronRight from "../../../resources/images/nftf/chevron-right.svg";
import { LoadingLayer } from "../../common/Layer/Loading";
import CommonNoticeText from "../../common/NoticeText/CommonNoticeText";
import ModalDetail from "../Modal/ModalDetail/ModalDetail";
import { CheckIcon, Checkbox } from "../Modal/ModalStyle";
import { PostApi1975 } from "../../../modules/network/padoPost";
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";

const ReceiptMain = props => {
  const {
    hsptInfo,
    trgtInfo,
    familyInfo,
    smptInfo,
    cardInfo,
    pharmInfo,
    submit,
    setPageIdx,
    hsptData,
    modalView,
    setModalView,
    seqNo,
    receiptStatus,
    test,
  } = props;
  const { userinfo, cfg, phonecfg, nftfDoctor } = useContext(AppContext);

  // const [toggle, setToggle] = useState(false);
  const [toggle, setToggle] = useState(true);
  const [btnActive, setBtnActive] = useState(true);
  const [modalDetailView, setModalDetailView] = useState(false);

  const [layerView, setLayerView] = useState(false);

  const convertDate = () => {
    let nowDate = new Date();
    let toMonth = checkNum10(nowDate.getMonth() + 1);
    let toDay = checkNum10(nowDate.getDate());

    const ampmToString =
      hsptInfo.ampm === "am" || hsptInfo.ampm === "AM" ? "오전" : "오후";

    const viewHour =
      hsptInfo.ampm === "am" || hsptInfo.ampm === "AM"
        ? hsptInfo.hour
        : parseInt(hsptInfo.hour) - 12;

    return (
      toMonth +
      "월 " +
      toDay +
      "일" +
      "(" +
      getWeekday(nowDate.getFullYear() + toMonth + toDay) +
      ") " +
      ampmToString +
      " " +
      viewHour +
      ":" +
      hsptInfo.min +
      " - " +
      hsptInfo.doctor.doctorName
    );
  };

  const toggleCheck = () => {
    if (toggle) {
      if (btnActive) {
        setBtnActive(false);
        if (seqNo) {
          if (cardInfo) {
            submit(setBtnActive);
          } else {
            alert("결제카드를 선택하세요");
          }
        } else {
          // setPageIdx(10);
          setPageIdx(5);
        }
      }
    } else {
      alert("개인정보 수집 및 제공에 동의하세요");
    }
  };

  const convertBirth = date => {
    return (
      date.substring(0, 4) +
      "년 " +
      date.substring(4, 6) +
      "월 " +
      date.substring(6, 8) +
      "일"
    );
  };

  useEffect(() => {
    if (seqNo != null) {
      // getIdCard(userinfo.userName);
      getMyCoupon();
    }
  }, []);

  const returnStatus = target => {
    switch (target) {
      case "time": {
        if (!hsptInfo) {
          return "active";
        } else if (receiptStatus != null && receiptStatus != "1") {
          return "disable";
        } else {
          return "default";
        }
      }

      case "symptom": {
        if (hsptInfo && !smptInfo) {
          return "active";
        } else if (smptInfo) {
          if (receiptStatus != null && parseInt(receiptStatus) >= 7) {
            return "disable";
          } else {
            return "default";
          }
        } else {
          return "disable";
        }
      }

      case "idCard": {
        if (hsptInfo && smptInfo && !trgtInfo) {
          return "active";
        } else if (trgtInfo) {
          // if (receiptStatus != null && receiptStatus != "1") {
          if (receiptStatus != null) {
            return "disable";
          } else {
            return "default";
          }
        } else {
          return "disable";
        }
      }

      case "card": {
        if (hsptInfo && smptInfo && trgtInfo && !cardInfo) {
          return "active";
        } else if (cardInfo) {
          return "default";
        } else {
          return "disable";
        }
      }

      case "pharm": {
      }
    }
  };

  const returnRIcon = target => {
    if (returnStatus(target) === "active") {
      return ListIcon.RECEIPT.R_ICON.CHEVRON_ACTIVE;
    } else if (returnStatus(target) === "default") {
      return ListIcon.RECEIPT.R_ICON.CHEVRON_DEFAULT;
    } else {
      return "";
    }
  };

  const [couponList, setCouponList] = useState([]);
  const getMyCoupon = () => {
    PostApi1975(userinfo, cfg, "TM", "TM")
      .then(result => {
        if (result.rsltCd === "E000") {
          setCouponList(result.rslt);
          // if (result.rslt.length > 0) {
          //   props.setCouponListView(true);
          // }
          // setUseCoupon(result.rslt[0]);
          // setIssueCpnNo(result.rslt[0].issueCpnNo);
        }
      })
      .catch(err => {
        console.log("err:: ", err);
      });
  };

  return (
    <Fragment>
      <ScrollToTop />
      {modalDetailView === false ? (
        <BackgroundDiv>
          <HeaderTitle>
            <div
              style={{ width: "40px", height: "40px" }}
              onClick={() => {
                seqNo == null ? setLayerView(true) : _O.Open("/resrvList");
              }}>
              <img src={IC.etc.ICON_CHEVRON_LEFT} />
            </div>
            <div>{props.hederTitle}</div>
            <div style={{ width: "40px", height: "40px" }}>
              {/* <img src={ArrowLeft} /> */}
            </div>
          </HeaderTitle>
          <ContentBody>
            {hsptInfo && trgtInfo && smptInfo && cardInfo ? (
              <NoticeText>
                {hsptData.hpName}의
                <br />
                예약정보를 확인해주세요
              </NoticeText>
            ) : (
              <NoticeText>
                순서대로 예약을
                <br />
                진행해주세요
              </NoticeText>
            )}
            <SelectDivArea>
              {/* <SelectedDiv active={true} onClick={() => props.setPageIdx(2)}> */}
              <SelectedDiv
                active={
                  receiptStatus != null && receiptStatus != "1" ? false : true
                }
                activeData={
                  receiptStatus != null && receiptStatus != "1" ? true : false
                }
                onClick={() => {
                  receiptStatus != null && receiptStatus != "1"
                    ? null
                    : props.setPageIdx(2);
                }}>
                <List
                  data={{
                    CONTAINER_SHORT: true,
                    STATUS: returnStatus("time"),
                    L_ICON: (
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          textAlign: "center",
                          lineHeight: "42px",
                        }}>
                        <img src={ListIcon.RECEIPT.L_ICON.TIME} />
                      </div>
                    ),
                    TITLE: "진료시간 / 의료진",
                    SUB_TEXT: {
                      status: !hsptInfo
                        ? nftfDoctor
                          ? "default"
                          : "active"
                        : "default",
                      text: !hsptInfo
                        ? nftfDoctor
                          ? nftfDoctor.doctor[0].doctorName
                          : ""
                        : convertDate(),
                    },
                    R_ICON: returnRIcon("time"),
                    ACTION: "",
                  }}
                />
              </SelectedDiv>

              <SelectedDiv
                active={hsptInfo ? true : false}
                activeData={
                  receiptStatus != null && parseInt(receiptStatus) >= 7
                    ? true
                    : false
                }
                onClick={
                  receiptStatus == null
                    ? hsptInfo && (() => props.setPageIdx(4))
                    : parseInt(receiptStatus) < 7
                    ? () => props.setPageIdx(4)
                    : null
                }>
                <List
                  data={{
                    CONTAINER_SHORT: true,
                    STATUS: returnStatus("symptom"),
                    L_ICON: (
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          textAlign: "center",
                          lineHeight: "42px",
                        }}>
                        <img src={ListIcon.RECEIPT.L_ICON.COMMENT} />
                      </div>
                    ),
                    TITLE: "증상",
                    SUB_TEXT: {
                      status: hsptInfo && !smptInfo ? "active" : "default",
                      text: !smptInfo ? "" : smptInfo.symptomText,
                    },
                    R_ICON: returnRIcon("symptom"),
                    ACTION: "",
                  }}
                />
              </SelectedDiv>
              <SelectedDiv
                // active={smptInfo && receiptStatus != "1" ? true : false}
                active={smptInfo && receiptStatus == null ? true : false}
                activeData={
                  // receiptStatus != null && receiptStatus != "1" ? true : false
                  receiptStatus == null ? true : false
                }
                onClick={
                  receiptStatus == null
                    ? smptInfo && (() => props.setPageIdx(3))
                    : // : receiptStatus == "1"
                      // ? smptInfo && (() => props.setPageIdx(3))
                      null
                }>
                <List
                  data={{
                    CONTAINER_SHORT: true,
                    STATUS: returnStatus("idCard"),
                    L_ICON: (
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          textAlign: "center",
                          lineHeight: "42px",
                        }}>
                        <img src={ListIcon.RECEIPT.L_ICON.IDCARD} />
                      </div>
                    ),
                    TITLE: "진료 대상",
                    SUB_TEXT: {
                      status:
                        hsptInfo && smptInfo && !trgtInfo
                          ? "active"
                          : "default",
                      text: !trgtInfo
                        ? ""
                        : familyInfo.famzNm +
                          " " +
                          convertBirth(familyInfo.famzBirthDt),
                    },
                    R_ICON: returnRIcon("idCard"),
                    ACTION: "",
                  }}
                />
              </SelectedDiv>

              {seqNo && (
                <SelectedDiv
                  active={smptInfo && trgtInfo ? true : false}
                  onClick={smptInfo && trgtInfo && (() => props.setPageIdx(5))}>
                  {/* onClick={
                    smptInfo && trgtInfo && (() => props.setPageIdx(10))
                  }> */}
                  <List
                    data={{
                      CONTAINER_SHORT: true,
                      STATUS: returnStatus("card"),
                      L_ICON: (
                        <div
                          style={{
                            width: "32px",
                            height: "32px",
                            textAlign: "center",
                            lineHeight: "42px",
                          }}>
                          <img src={ListIcon.RECEIPT.L_ICON.CARD} />
                        </div>
                      ),
                      TITLE: "결제수단",
                      SUB_TEXT: {
                        status:
                          hsptInfo && smptInfo && trgtInfo && !cardInfo
                            ? "active"
                            : "default",
                        text: !cardInfo
                          ? ""
                          : cardInfo.cardNm + "-" + cardInfo.cardNo,
                      },
                      R_ICON: returnRIcon("card"),
                      ACTION: "",
                    }}
                  />
                </SelectedDiv>
              )}
              {seqNo && (
                // <SelectedDiv active={true} onClick={() => props.setPageIdx(10)}>
                // appStatus 1:신청 2:접수중 3.접수4.확정요청7:접수완료 8:병원마감 9:취소
                <SelectedDiv
                  active={parseInt(receiptStatus) < 4 ? true : false}
                  onClick={e =>
                    parseInt(receiptStatus) < 4 &&
                    couponList &&
                    couponList.length > 0
                      ? props.setCouponListView(true)
                      : e.preventDefault()
                  }>
                  <List
                    data={{
                      CONTAINER_SHORT: true,
                      STATUS:
                        parseInt(receiptStatus) < 4 ? "default" : "disable",
                      L_ICON: (
                        <div
                          style={{
                            width: "32px",
                            height: "32px",
                            textAlign: "center",
                            lineHeight: "42px",
                          }}>
                          <img src={ListIcon.RECEIPT.L_ICON.COUPON} />
                        </div>
                      ),
                      TITLE: "쿠폰정보",
                      SUB_TEXT: {
                        status: "default",
                        text:
                          props.couponInfo && props.couponInfo.cpnNm != ""
                            ? props.couponInfo.cpnNm
                            : "쿠폰정보 없음",
                      },
                      R_ICON:
                        parseInt(receiptStatus) < 4 &&
                        couponList &&
                        couponList.length > 0
                          ? returnRIcon("card")
                          : "",
                      ACTION: "",
                    }}
                  />
                </SelectedDiv>
              )}

              <SelectedDiv
                active={smptInfo && trgtInfo ? true : false}
                onClick={smptInfo && trgtInfo && (() => props.setPageIdx(7))}>
                <List
                  data={{
                    CONTAINER_SHORT: true,
                    STATUS:
                      hsptInfo && smptInfo && trgtInfo && !pharmInfo
                        ? "default"
                        : pharmInfo
                        ? "default"
                        : "disable",
                    L_ICON: (
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          textAlign: "center",
                          lineHeight: "42px",
                        }}>
                        <img src={ListIcon.RECEIPT.L_ICON.MEDICAL} />
                      </div>
                    ),
                    TITLE: "약국정보",
                    SUB_TEXT: {
                      status: "default",
                      // hsptInfo && smptInfo && trgtInfo && !pharmInfo
                      // ? "active"
                      // : "default",
                      // text: !pharmInfo ? "" : pharmInfo.pharmName,
                      text: !pharmInfo
                        ? hsptInfo && smptInfo && trgtInfo
                          ? "약국정보 없음"
                          : ""
                        : pharmInfo.pharmName,
                    },
                    R_ICON:
                      hsptInfo && smptInfo && trgtInfo && !pharmInfo
                        ? // ? ListIcon.RECEIPT.R_ICON.CEHVRON_ACTIVE
                          ListIcon.RECEIPT.R_ICON.CHEVRON_DEFAULT
                        : pharmInfo
                        ? ListIcon.RECEIPT.R_ICON.CHEVRON_DEFAULT
                        : "",
                    ACTION: "",
                  }}
                />
              </SelectedDiv>
              <CommonNoticeText
                title="비대면진료 신청시 해당 병원에 연동됩니다."
                text=""
                psIcon={true}
              />
            </SelectDivArea>
          </ContentBody>

          {hsptInfo && trgtInfo && smptInfo && (
            <Fragment>
              <div
                style={{
                  background: "#fff",
                  position: "fixed",
                  bottom: "0px",
                  paddingBottom: "24px",
                  display: "flex",
                  flexFlow: "column",
                  gap: "28px",
                  width: "100%",
                }}>
                {/* <Checkbox
                  style={{
                    bottom: "106px",
                    // position: "fixed",
                    padding: "0 20px",
                  }}>
                  <CheckIcon
                    type="checkbox"
                    onClick={() => setToggle(!toggle)}
                  />
                  개인정보 수집 및 제공에 동의합니다
                </Checkbox> */}

                <BottomBtnArea style={{ position: "static" }}>
                  <Button
                    severity="primary"
                    disable="off"
                    clickEvent={() => toggleCheck()}>
                    {/* {seqNo ? "수정" : "비대면진료 예약"} */}
                    {seqNo ? "수정" : "다음"}
                  </Button>
                </BottomBtnArea>
              </div>
            </Fragment>
          )}

          <LoadingLayer />
        </BackgroundDiv>
      ) : (
        <ModalDetail rightClickEvent={() => setModalDetailView(false)} />
      )}

      {layerView && (
        <Layer
          title="다음에 다시 예약하시겠어요?"
          desc={["입력하신 정보는 저장되지 않습니다"]}
          ps=""
          button={[
            {
              severity: "light",
              disable: "off",
              small: true,
              clickEvent: () => setLayerView(false),
              text: "아니오",
            },

            {
              severity: "primary",
              disable: "off",
              small: true,
              clickEvent: () => {
                _O.Open("/surround");
              },
              text: "네",
            },
          ]}
        />
      )}
    </Fragment>
  );
};

const SelectDivText = (props) => {
  return (
    <Fragment>
      <div>
        {props.showImgYn && <img src={PurpleDot} />}
        {props.text}
      </div>
      <img src={ChevronRight} style={{ marginLeft: "auto" }} />
    </Fragment>
  );
};

export default ReceiptMain;
